import React from "react";
import styled from "styled-components";
import styles from "../Nav/nav.module.css";
import logo3 from "../../images/logo3.png";

const MonitorBox = ({
  popupItem,
  frameColor,
  size,
  logo,
  colorUnit = "#4a4a4a",
}) => {
  size = 384;

  return (
    <Box>
      <Box style={{ flexDirection: "row" }}>
        <Wrapper frameColor={frameColor} size={size}>
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "flex-end",
            }}
          ></div>
          <ScreenWrapper>
            <img
              style={{
                objectFit: "contain",
                width: "99%",
                height: logo ? "99%" : null,
              }}
              className={styles.LolinkImg}
              src={logo || logo3}
              alt="logo"
            />
          </ScreenWrapper>
        </Wrapper>
        {/*<DividerVertical size={size} />*/}
      </Box>
      <WhiteBackground style={{ opacity: !popupItem ? 0 : 0.5 }} />
    </Box>
  );
};

const Box = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  z-index: -1;
`;

const Wrapper = styled.div`
  width: 180px;
  height: ${({ size }) => size}px;
  align-items: center;
  justify-content: center;
  //box-shadow: 2px 2px 5px #bababa;
  position: relative;
  display: flex;
  border-radius: 2px;
  background-color: ${({ frameColor }) => frameColor};
`;

const ScreenWrapper = styled.div`
  width: 125px;
  height: 210px;
  align-items: center;
  justify-content: center;
  box-shadow: inset 1px 0 3px #bababa;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  margin-bottom: 30px;
  background-image: linear-gradient(to bottom, #ffffff, #e5e5e5);
`;

const WhiteBackground = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  z-index: 100;
  transition: all 300ms ease-in-out;
`;
export { MonitorBox };
